module.exports = __webpack_public_path__ + "img/33.8d15e14d.png";